import { i18n } from '@/i18n'
import { ActivityLogParser } from '@/parsers/activityLog'
import { getContactAddress } from '@/helpers/contact'

export class AddressActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'category.id': 'addressCategory',
        'label.id': 'addressLabel',
        'po_box': 'boolean',
        'country.id': 'country',
        'valid_from': 'date',
        'valid_until': 'date',
        'is_main_correspondence_address': 'boolean',
    }

    static getAddressDetails (activityLog) {
        const addressDetails = []
        const address = activityLog.properties.attributes ?? activityLog.properties.old

        if (address) {
            addressDetails.push(`<address>`)
            const label = this.getFormattedLogDetailValue(activityLog, 'addressLabel', this.attributeDataTypes['label.id'], address['label.id'])
            if (typeof label !== 'undefined') addressDetails.push(`<span class="additional-info">${label}:</span>\n`)
            addressDetails.push(getContactAddress(address, { multiline: true }))
            addressDetails.push(`</address>`)
        }

        return addressDetails.join('')
    }

    static getLogDetailsCreated (activityLog, data) {
        const logDetails = []

        logDetails.push (
            {
                key: 'address',
                newValue: this.getAddressDetails(activityLog),
            }
        )

        if (activityLog.properties.attributes.valid_from) {
            logDetails.push (
                {
                    key: 'valid_from',
                    label: i18n.tc('forms.field.label.address.valid-from', 1),
                    newValue: this.getFormattedLogDetailValue(activityLog, 'valid_from', this.attributeDataTypes['valid_from'] ?? 'undefined', activityLog.properties.attributes.valid_from),
                }
            )
        }

        if (activityLog.properties.attributes.valid_until) {
            logDetails.push (
                {
                    key: 'valid_until',
                    label: i18n.tc('forms.field.label.address.valid-until', 1),
                    newValue: this.getFormattedLogDetailValue(activityLog, 'valid_until', this.attributeDataTypes['valid_until'] ?? 'undefined', activityLog.properties.attributes.valid_until),
                }
            )
        }

        if (activityLog.properties.attributes.is_main_correspondence_address) {
            logDetails.push (
                {
                    key: 'is_main_correspondence_address',
                    label: i18n.tc('forms.field.label.address.is-main-correspondence-address', 1),
                    newValue: this.getFormattedLogDetailValue(activityLog, 'is_main_correspondence_address', this.attributeDataTypes['is_main_correspondence_address'] ?? 'undefined', activityLog.properties.attributes.is_main_correspondence_address),
                }
            )
        }

        return logDetails
    }

    static getLogDetailsDeleted (activityLog, data) {
        const logDetails = []

        logDetails.push (
            {
                key: 'address',
                oldValue: this.getAddressDetails(activityLog),
            }
        )

        if (activityLog.properties.old.valid_from) {
            logDetails.push (
                {
                    key: 'valid_from',
                    label: i18n.tc('forms.field.label.address.valid-from', 1),
                    oldValue: this.getFormattedLogDetailValue(activityLog, 'valid_from', this.attributeDataTypes['valid_from'] ?? 'undefined', activityLog.properties.old.valid_from),
                }
            )
        }

        if (activityLog.properties.old.valid_until) {
            logDetails.push (
                {
                    key: 'valid_until',
                    label: i18n.tc('forms.field.label.address.valid-until', 1),
                    oldValue: this.getFormattedLogDetailValue(activityLog, 'valid_until', this.attributeDataTypes['valid_until'] ?? 'undefined', activityLog.properties.old.valid_until),
                }
            )
        }

        if (activityLog.properties.old.is_main_correspondence_address) {
            logDetails.push (
                {
                    key: 'is_main_correspondence_address',
                    label: i18n.tc('forms.field.label.address.is-main-correspondence-address', 1),
                    oldValue: this.getFormattedLogDetailValue(activityLog, 'is_main_correspondence_address', this.attributeDataTypes['is_main_correspondence_address'] ?? 'undefined', activityLog.properties.old.is_main_correspondence_address),
                }
            )
        }

        return logDetails
    }
}
